import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  FiChevronRight,
  FiHome,
} from "react-icons/fi";

import { getAutoPoolIncome } from "../../store/slices/fund";

const AutoPoolIncome = () => {
  const dispatch = useDispatch();

  const {
    autoPoolIncome,
    autoPoolIncomeLoading,
    autoPoolIncomeError,
  } = useSelector((state) => state.fund);

  useEffect(() => {
    dispatch(getAutoPoolIncome());
  }, [dispatch]);

  const incomes = Array.isArray(autoPoolIncome?.records)
    ? autoPoolIncome.records
    : [];

  const formatDate = (date) => {
    if (!date) {
      return "-";
    }

    const parsedDate = new Date(date);

    if (Number.isNaN(parsedDate.getTime())) {
      return "-";
    }

    return parsedDate.toLocaleString("en-IN", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  };

  const formatNumber = (number) => {
    return Number(number || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };

  return (
    <div className="gi-referral-page">

      <div className="gi-breadcrumb">

        <Link to="/dashboard">
          <FiHome />
          Dashboard
        </Link>

        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>
          Income Report
        </span>
        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>
          Auto Pool Income
        </span>

      </div>

      <section className="gi-referral-table-card">


        <div className="gi-referral-table-wrapper">

          <table className="gi-referral-table">

            <thead>

              <tr>

                <th className="text-center">
                  #
                </th>


                <th className="text-center">
                  Paid Pool
                </th>

                <th className="text-center">
                  Auto Pool Income
                </th>

                <th className="text-center">
                  Income Type
                </th>

                <th className="text-center">
                  Date
                </th>

                <th className="text-center">
                  Status
                </th>

              </tr>

            </thead>

            <tbody>


              {autoPoolIncomeLoading && (

                <tr>

                  <td
                    colSpan="8"
                    className="gi-table-message text-center"
                  >
                    Loading auto pool income...
                  </td>

                </tr>

              )}


              {!autoPoolIncomeLoading &&
                autoPoolIncomeError && (

                  <tr>

                    <td
                      colSpan="8"
                      className="gi-table-message text-center"
                    >
                      {autoPoolIncomeError}
                    </td>

                  </tr>

                )}


              {!autoPoolIncomeLoading &&
                !autoPoolIncomeError &&
                incomes.length === 0 && (

                  <tr>

                    <td
                      colSpan="8"
                      className="gi-table-message text-center"
                    >
                      No auto pool income found
                    </td>

                  </tr>

                )}


              {!autoPoolIncomeLoading &&
                !autoPoolIncomeError &&
                incomes.map((item, index) => {

                  const serialNumber = index + 1;

                  return (

                    <tr
                      key={
                        item?._id || index
                      }
                    >


                      <td className="gi-referral-number text-center">

                        {String(
                          serialNumber
                        ).padStart(2, "0")}

                      </td>

                      <td className="text-center">

                        Pool{" "}
                        {item?.paidPool || "-"}



                      </td>



                      <td className="text-center">

                        <strong className="gi-income-amount">

                          $
                          {formatNumber(
                            item?.reward
                          )}

                        </strong>

                      </td>


                      <td className="text-center">

                        <span className="gi-income-type">

                          {item?.remarks || "-"}

                        </span>

                      </td>

                      <td className="text-center">

                        <span className="gi-date-text">

                          {formatDate(
                            item?.createdAt
                          )}

                        </span>

                      </td>


                      <td className="text-center">

                        <span className="gi-status-badge active">

                          Success

                        </span>

                      </td>

                    </tr>

                  );

                })}

            </tbody>

          </table>

        </div>

      </section >

    </div >
  );
};

export default AutoPoolIncome;